module.exports = __webpack_public_path__ + "static/img/hy03.761d288f.png";